import type { ReactNode } from "react";
import { useRef, useState } from "react";

import SchedulePalettePopup from "@/pages/human-resources/time-management/components/schedule-palette/popup/SchedulePalettePopup.tsx";
import IconButton from "@/shared/components/generic/button/IconButton.tsx";
import IconClock from "@/shared/components/generic/icons/IconClock.tsx";
import type { Size } from "@/shared/components/generic/UiEnums.ts";
import { Level } from "@/shared/components/generic/UiEnums.ts";
import BasicTooltipWithOffset from "@/pages/human-resources/time-management/components/BasicTooltipWithOffset.tsx";
import { useTranslation } from "react-i18next";

interface Properties {
  buttonSize: Size;
  disabled: boolean;
}

export default function SchedulePaletteOpener(props: Properties): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  const [popupOpen, setPopupOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  function toggleOpenPopup(): void {
    setPopupOpen((open) => !open);
  }

  return (
    <div ref={anchorRef}>
      <BasicTooltipWithOffset title={t("schedulePalette")}>
        <IconButton
          icon={IconClock}
          level={Level.TERTIARY}
          size={props.buttonSize}
          disabled={props.disabled}
          onClick={toggleOpenPopup}
        />
      </BasicTooltipWithOffset>
      <SchedulePalettePopup
        anchorElement={anchorRef.current}
        open={popupOpen}
        onClose={() => {
          setPopupOpen(false);
        }}
      />
    </div>
  );
}
